module.exports = __webpack_public_path__ + "img/TAM New Work Facilitator Badge.168230ea.png";